module.exports = __webpack_public_path__ + "static/img/autCt_bg_04.a7ac67b1.svg";